/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { QueryParam } from '@common/types';

export interface LoginInfo {
  loginLink: string;
}

export type UserLogoutResponse = {
  redirectURL: string;
};

export type BasicRedirectInfo = {
  redirectUrl: QueryParam;
};

export type ValidateRedirectUrlRequestData = {
  type: string;
  data: {
    redirectUrl: BasicRedirectInfo['redirectUrl'];
  };
};

export enum AuthStatus {
  UNKNOWN,
  AUTHORIZED,
  UNAUTHORIZED,
  FORBIDDEN
}

export const StatusToAuthStatus = {
  '401': AuthStatus.UNAUTHORIZED,
  '403': AuthStatus.FORBIDDEN
};
